import React, { useEffect, useState } from "react";
import { useMobile } from "./hooks/token/useMobile";
import { useAccressToken } from "./hooks/token/useAccessToken";
import { useRecoilState, useRecoilValue } from "recoil";
import { User } from "./types";
import { userState } from "./states/userState";
import { accessTokenState } from "./states/accessTokenState";
import Login from "./components/pages/login/Login";

const isAuthCheck = ({
  token,
  isMobile,
  isSignedIn,
  tokenState,
}: {
  token: string;
  isMobile: boolean | null;
  isSignedIn: boolean;
  tokenState: string;
}) => {
  console.log(
    "アカウント状態:",
    "isSignedIn",
    isSignedIn,
    "token",
    token,
    "tokenState",
    tokenState,
    "isMobile",
    isMobile
  );
  if (isMobile !== null && isMobile) {
    return isSignedIn;
  } else if (isMobile !== null && !isMobile) {
    return Boolean(token && isSignedIn && tokenState);
  } else {
    return false;
  }
};
const Auth = ({ children }: { children: React.ReactNode }) => {
  const { isMobile } = useMobile();
  const [isAuth, setIsAuth] = useState<boolean>(false);
  const [user, setUser] = useRecoilState<User>(userState);
  const accsessToken = useRecoilValue(accessTokenState);
  //const isSignedIn = false;
  const { token, setToken } = useAccressToken();
  const [wait, setWait] = useState(true);
  useEffect(() => {
    const timerId = setTimeout(() => setWait(false), 1000);
    return () => clearTimeout(timerId);
  }, []);
  useEffect(() => {
    const result = isAuthCheck({
      token: token,
      isMobile: isMobile,
      isSignedIn: user.isAuth,
      tokenState: accsessToken,
    });
    console.log(
      "現在のアクセストークンAuth:",
      { token },
      { accsessToken },
      { user },
      { result }
    );

    setIsAuth(result);
  }, [accsessToken, token, user.isAuth, accsessToken, isMobile]);
  if (wait) return <></>;
  if (isAuth) {
    return <>{children}</>;
  } else {
    return <Login />;
  }
  // return <>{children}</>;
};

export default Auth;
